import React from "react";
import { useTranslation } from "react-i18next";

import { InteractionEventTypes } from "../../../../redux/services/config";

import styles from "./CentreControl.module.scss";

export const inactivityModalDataQa = "inactivity-modal";

export interface CentreControlProps {
  isInactive: boolean;
  onTouch?: (eventType: InteractionEventTypes.SESSION_EXTENDER_TOUCH) => void;
  countdownTimeInSeconds: number;
}

const CentreControl: React.FC<CentreControlProps> = ({
  isInactive,
  onTouch,
  countdownTimeInSeconds,
}) => {
  const { t } = useTranslation();

  const handleExtendSession = () =>
    onTouch && onTouch(InteractionEventTypes.SESSION_EXTENDER_TOUCH);

  return isInactive ? (
    <div
      className={styles.container}
      data-qa={inactivityModalDataQa}
      onClick={handleExtendSession}
    >
      <div className={styles.content}>
        <p className={styles.title}>{t("session_timeout.title")}</p>
        <div className={styles.countDownTextContainer}>
          <p className={styles.countDownText}>{countdownTimeInSeconds}</p>
        </div>
        <p className={styles.subtitle}>{t("session_timeout.message")}</p>
      </div>
    </div>
  ) : null;
};

export default CentreControl;
